

































































































import { Component } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditMerchant from "./edit-merchant.vue";
import CreateMerchant from "./create-merchant.vue";

class PageMerchantRequest extends PageRequest {
  name?: string;
  supplierId?: number;
}

@Component({
  components: { EditMerchant, CreateMerchant },
})
export default class Merchant extends AbpBase {
  // 查询参数
  pagerequest: PageMerchantRequest = new PageMerchantRequest();

  editModalShow: boolean = false;
  createModalShow: boolean = false;

  // ================== computed ==================
  get list() {
    return this.$store.state.merchant.list;
  }

  get loading() {
    return this.$store.state.merchant.loading;
  }

  get pageSize() {
    return this.$store.state.merchant.pageSize;
  }

  get totalCount() {
    return this.$store.state.merchant.totalCount;
  }

  get currentPage() {
    return this.$store.state.merchant.currentPage;
  }
  create() {
    this.createModalShow = true;
  }
  // ================== 表格列 ==================
  columns = [
    {
      title: "商户名称",
      key: "name",
    },
    {
      title: "AppId",
      key: "appId",
    },
    {
      title: "商户号(MID)",
      key: "mid",
    },
    {
      title: "终端号(TID)",
      key: "tid",
    },
    {
      title: "是否主商户",
      key: "isMain",
      width: 120,
      render: (h: any, params: any) => {
        return h("span", params.row.isMain ? "是" : "否");
      },
    },
    {
      title: "创建时间",
      key: "creationTime",
      width: 180,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.creationTime
            ? new Date(params.row.creationTime).toLocaleString()
            : "-"
        );
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 120,
      align: "center",
      slot: "action",
    },
  ];

  // ================== 方法 ==================

  edit() {
    this.editModalShow = true;
  }

  menuClick(name, row) {
    switch (name) {
      case "edit":
        this.$store.commit("merchant/edit", row);
        this.edit();
        break;
      case "delete":
        this.$Modal.confirm({
          title: "提示",
          content: "确定要删除该商户吗？",
          okText: "确定",
          cancelText: "取消",
          onOk: async () => {
            await this.$store.dispatch({
              type: "merchant/delete",
              data: row,
            });
            await this.getpage();
          },
        });
        break;
    }
  }

  pageChange(page: number) {
    this.$store.commit("merchant/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("merchant/setPageSize", pagesize);
    this.getpage();
  }

  search() {
    this.$store.commit("merchant/setCurrentPage", 1);
    this.getpage();
  }

  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;

    await this.$store.dispatch({
      type: "merchant/getAll",
      data: this.pagerequest,
    });
  }

  async created() {
    this.getpage();
  }
}
